<template>
    <div :class="{'isBE' : isBE, 'isNCH': isNCH }">
        <div v-show="isBE" style="clear:both"></div>
        <div v-show="venueHasDiscountCode">
            <div class="discount-code-block" style="min-height: 20px;">
                <div>
                    <a href="#" v-show="!link_clicked" @click.prevent="clickLink()"><span v-html="show_link_text"></span></a>
                    <a href="#" v-show="link_clicked" @click.prevent="clickLink()">{{strings.hide_discount_code}}</a>
                </div>
                <div v-show="link_clicked" class="discount-code-wrapper">
                    <p class="helptext">{{strings.add_discount_code}}</p>
                    <!--- <input  v-on:blur="applyDiscountCodeOnBlur($event.target.value)" type="text" class="form__input" :placeholder="strings.code" v-model="_s_code" > !--->
                    <input  type="text" class="form__input" :placeholder="strings.code" v-model="_s_code" >
                    <button  type="submit" href="" class="button" @click.prevent="applyDiscountCode()">{{ strings.apply }}</button>
                    <div style="clear:both;"></div>
                </div>
            </div>
            <MPDiscountCodeErrorBlock v-if="!isBE" />
        </div>
    </div>
</template>

<script>
import MPDiscountCodeErrorBlock from './DiscountCodeErrorBlock';

export default {
    components: {
      MPDiscountCodeErrorBlock
    },
    data () {
        return {
            _s_code: '',
            _discount_code : '',
            link_clicked : false,
                    }
    },
    mounted() {
        this._s_code = this.$store.state.discount_code;
    },
    computed: {
        venueHasDiscountCode(){
            return this.$store.state.venueInfo.venue_has_discount_code
        },
        isBE() {
            return this.$store.state.isBE;
        },
        haveDiscountCode() {
            if(this.$store.state.discount_code){
                return true;
            } else {
                return false;
            }
        },
        isNCH(){
            return this.$store.state.isNCH;
        },
        isOpera(){
            return this.$store.state.isOpera;
        },
        show_link_text: {
            get: function () {
                let text = '';
                if(!this.$store.state.discount_code){
                    text = this.$store.state.strings.haveADiscountCode;
                }else{
                    text = "<b>" +this.$store.state.discount_code + "</b> " +this.$store.state.strings.code_in_use;
                }
                return text;
            },
            set: function () {
            }
        },
        isLoading(){
            return this.$store.state.discountCodeLoading;
        },
        strings() {
            return this.$store.state.strings;
        },
        s_code: {
            get: function () {
                this._discount_code = this.$store.state.discount_code;
                return this.$store.state.discount_code;
            },
            set: function (code) {
                this._s_code = code;
            }
        },
        currentTab() {
            return this.$store.state.currentTab;
        },
        discount_code() {
            return this.$store.state.discount_code;
        },
        discPriceErrorShouldShow() {
            return this.$store.state.discPriceErrorShouldShow;
        }
    },
    methods: {
        clickLink(){
            this.link_clicked = !this.link_clicked;
        },
        applyDiscountCodeOnBlur(value){
            if(value != this._discount_code){
                this._discount_code = value;
                this.$store.commit('setDiscountCode', this._discount_code);

                // Should set to cookie as well.
                this.$cookie.set('discount_code', this._discount_code);

                if(this.currentTab == 'room'){
                    this.$store.dispatch('checkAvailabilityandPrices', {fromDiscountCode: true});
                } else {
                    this.$store.dispatch('checkAvailabilityandPricesfromPackage', {fromDiscountCode: true});
                }
            }
        },
        applyDiscountCode(){
            if(typeof this._s_code == 'undefined'){
                this._s_code = '';
            }
            this._discount_code = this._s_code;
            this.$store.commit('setDiscountCode', this._discount_code);
            this.$cookie.set('discount_code', this._discount_code);
            if(this.currentTab == 'room'){
                if(this.isOpera){
                    this.$store.dispatch('getRoomOpera');
                } else {
                    this.$store.dispatch('getRoom', {fromDiscountCode: true});
                }

            } else {
                if(this.isOpera){
                    this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
                } else {
                    this.$store.dispatch('checkAvailabilityandPricesfromPackage', {fromDiscountCode: true});
                }
            }
        }
        
    },
    watch: {
        discount_code(code) {
            this._discount_code = code;
        }
    }
}
</script>

<style scoped>
    .form__input {
        width: 30%;
        float:left;
    }
    .discount-code-block{
        margin-right:5px;
    }
    .isBE .discount-code-block{
        margin-top:10px;
        margin-right:20px;
    }
    button {
        background-color: #0055a9;
        border: 1px solid #0055a9;
        width: 38%;
        margin-left: 2%;
        margin-top: 3px;
        max-height: 35px;
        min-height: 35px;
        line-height: 10px;
        width: 20%;
    }
    .discount-code-block a, .discount-code-block a:visited{
        float: right;
        color: black;
        text-decoration: underline;
    }

    .discount-code-block p {
        color: black;
        font-style: italic;
    }
    .discount-code-wrapper .v-spinner{
        float:none;
    }
    .discount-code-wrapper button{
        max-height:40px;
    }
    .discount-code-wrapper .v-pulse{
        width:14px!important;
        height: 14px!important;
    }
    .discount-code-block .helptext{
        margin-bottom: 0px;
        font-size: 12px;
        padding-left: 5px;
            font-style: normal;
    }
    .discount-code-wrapper{
        margin-left:5px;
    }
    .discount-code-error{
        color:red;
        margin-bottom: 0px;
        margin-top: 20px;    
    }
    .isBE .discount-code-wrapper{
        width:85%;
        margin-left:0px;
    }
    .isBE .discount-code-wrapper button{
        margin-left: 2.5%!important;
        width: 18%!important;
    }
    .isNCH .discount-code-wrapper button{
        background-color: #00aa50!important;
        border: 1px solid #00aa50!important;
    }
     @media screen and (max-width: 640px) {
        .isNCH .discount-code-wrapper button{
            margin-top: 5px;
        }
    }
</style>
